'use client';

import React, { useRef } from 'react';
import { IIframeItem } from '@/lib/types';

interface IIframeItemProps extends IIframeItem {
  uniqueIdentifier: string;
  className?: string;
  onBlockClick?: () => void;
}

export const IframeItem: React.FC<IIframeItemProps> = ({ url, uniqueIdentifier, className, onBlockClick }) => {
  const itemRef = useRef<HTMLIFrameElement>(null);

  return (
    <div onClick={onBlockClick}>
      <iframe ref={itemRef} src={url} className={className} />
    </div>
  );
};
